/**@flow */

import React from "react";
import { localize } from "redux-i18n";
import { View, StatItem } from "@components";

type OwnProps = $Exact<{
  summary: $Exact<{
    total: number,
    general: number,
    absenceDocs: number,
    totlaFitNotes: number,
    numberToManager: string,
  }>,
  customItems?: Array<Object>,
  clientName: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class DocumentsSummary extends React.Component<Props> {
  get defaultItems() {
    return [
      {
        key: this.props.t("TOTAL_DOCUMENTS"),
        title: this.props.t("TOTAL_DOCUMENTS"),
        value: this.props.summary.total,
      },
      {
        key: this.props.t("GENERAL_DOCUMENTS"),
        title: this.props.t("GENERAL_DOCUMENTS"),
        value: this.props.summary.general,
      },
      {
        key: this.props.t("ABSENCE_SPECIFIC_DOCUMENTS"),
        title: this.props.t("ABSENCE_SPECIFIC_DOCUMENTS"),
        value: this.props.summary.absenceDocs,
      },
      {
        key: this.props.t("TOTAL_FIT_NOTES"),
        title: this.props.t("TOTAL_FIT_NOTES"),
        value: this.props.summary.totlaFitNotes,
      },
      {
        key: this.props.t("NEED_TO_CONTACT_EMPLOYEE_NAME"),
        title: (
          <div className="text-pumpkin-orange">
            {this.props.t("NEED_TO_CONTACT_EMPLOYEE_NAME", { name: this.props.clientName })}
          </div>
        ),
        value: (
          <p className="font-size-14 mt-0">
            <span>
              <span>{this.props.t("ABSENCE_HISTORY_CONTACT_EMPLOYEE_TEXT_1")}</span>
              <b>{this.props.summary.numberToManager}</b>
              <span>{this.props.t("ABSENCE_HISTORY_CONTACT_EMPLOYEE_TEXT_2")}</span>
            </span>
          </p>
        ),
        size: "small-m",
      },
    ];
  }

  get statItems() {
    return this.props.customItems || this.defaultItems;
  }

  render() {
    return (
      <View direction="row">
        {this.statItems.map(props => (
          <StatItem key={props.key} {...props} />
        ))}
      </View>
    );
  }
}

export default localize()(DocumentsSummary);
